import React, { Component } from "react";
import { connect } from "react-redux";
import { updateMotorTypeSelection } from "../actions/";

class CalculateHoistingForceAndRopeSpeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInputs: false,
      pressureHelpText: "",
      oilFlowHelpText: "",
      calcRopeSpeed: 0,
      calcPressure: 0,
      pressureUnit: "",
      oilFlowUnit: "",
      hoistingForceUnit: "",
      ropeSpeedUnit: "",
      showHoistingForce: false,
      showRopeSpeed: false
    };
    this.showCalcInputs = this.showCalcInputs.bind(this);
    this.onPressureChange = this.onPressureChange.bind(this);
    this.onOilFlowChange = this.onOilFlowChange.bind(this);
    this.selectHoistingForce = this.selectHoistingForce.bind(this);
    this.selectRopeSpeed = this.selectRopeSpeed.bind(this);
  }

  componentDidMount(prevProps) {
    if (this.props.mType === "metric") {
      this.setState({
        pressureUnit: "bar",
        oilFlowUnit: "l/min",
        hoistingForceUnit: "kN",
        ropeSpeedUnit: "m/min"
      });
    } else if (this.props.mType === "imperial") {
      this.setState({
        pressureUnit: "psi",
        oilFlowUnit: "gpm",
        hoistingForceUnit: "lbf",
        ropeSpeedUnit: "ft/min"
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.winchType.orderCode !== this.props.winchType.orderCode ||
      this.props.mType !== prevProps.mType ||
      this.props.drumSurface !== prevProps.drumSurface || 
      this.props.motorType.orderCode !== prevProps.motorType.orderCode
    ) {
      this.setState({
        pressureHelpText: "",
        oilFlowHelpText: "",
        calcRopeSpeed: 0,
        calcPressure: 0,
        showInputs: false
      });
      
      if (this.props.mType === "metric") {
        this.setState({
          pressureUnit: "bar",
          oilFlowUnit: "l/min",
          hoistingForceUnit: "kN",
          ropeSpeedUnit: "m/min"
        });
      } else if (this.props.mType === "imperial") {
        this.setState({
          pressureUnit: "psi",
          oilFlowUnit: "gpm",
          hoistingForceUnit: "lbf",
          ropeSpeedUnit: "ft/min"
        });
      }
      var textInputs = document.getElementsByClassName("calculation_inputs");
      for (var i = 0; i < textInputs.length; i++) {
        textInputs[i].value = "";
      }
    }
  }

  showCalcInputs() {
    this.setState({
      showInputs: true
    });
  }

  onPressureChange(event) {
    var regex = /^\d+$/;
    var pressure = event.target.value;
    var hForce = this.props.motorType.hoistingForce.value;
    var isValidPressure = regex.test(pressure);
    var maxPressure = this.props.motorType.hydraulicPressure.value;
    var minPressure = maxPressure / 2;
    if (!isValidPressure) {
      this.setState({
        pressureHelpText: "Not a valid value. Value should be only numbers"
      });
    } else if (parseInt(pressure, 10) > maxPressure) {
      this.setState({ pressureHelpText: "Value too high", calcPressure: 0 });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        hoistingForce: {
          ...this.props.motorType.hoistingForce,
          calcHoistingForce: null,

          name: this.props.motorType.hoistingForce.value
            .toString()
            .includes(".")
            ? this.props.motorType.hoistingForce.value
                .toString()
                .replace(".", ",")
            : this.props.motorType.hoistingForce.value.toString()
        },
        hydraulicPressure: {
          ...this.props.motorType.hydraulicPressure,
          enteredValue: null
        }
      });
    } else if (parseInt(pressure, 10) < minPressure) {
      this.setState({ pressureHelpText: "Value too low", calcPressure: 0 });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        hoistingForce: {
          ...this.props.motorType.hoistingForce,
          calcHoistingForce: null,

          name: this.props.motorType.hoistingForce.value
            .toString()
            .includes(".")
            ? this.props.motorType.hoistingForce.value
                .toString()
                .replace(".", ",")
            : this.props.motorType.hoistingForce.value.toString()
        },
        hydraulicPressure: {
          ...this.props.motorType.hydraulicPressure,
          enteredValue: null
        }
      });
    } else if (parseInt(pressure, 10) === maxPressure) {
      this.setState({
        pressureHelpText: "Value same as standard value",
        calcPressure: 0
      });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        hoistingForce: {
          ...this.props.motorType.hoistingForce,
          calcHoistingForce: null,

          name: this.props.motorType.hoistingForce.value
            .toString()
            .includes(".")
            ? this.props.motorType.hoistingForce.value
                .toString()
                .replace(".", ",")
            : this.props.motorType.hoistingForce.value.toString()
        },
        hydraulicPressure: {
          ...this.props.motorType.hydraulicPressure,
          enteredValue: null
        }
      });
    } else {
      if (this.props.mType === "metric") {
        var reqHoistingForce = parseFloat(
          (hForce * pressure) / maxPressure
        ).toFixed(1);
      } else {
        reqHoistingForce = Math.ceil((hForce * pressure) / maxPressure);
      }

      this.setState({ pressureHelpText: "" });
      this.setState({ calcPressure: reqHoistingForce });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        hoistingForce: {
          ...this.props.motorType.hoistingForce,
          calcHoistingForce: parseFloat(reqHoistingForce, 10),

          name: reqHoistingForce.toString().includes(".")
            ? reqHoistingForce.toString().replace(".", ",")
            : reqHoistingForce.toString(),
          actualValue: this.props.motorType.hoistingForce.value
        },
        hydraulicPressure: {
          ...this.props.motorType.hydraulicPressure,
          enteredValue: parseInt(pressure, 10),
          actualValue: this.props.motorType.hydraulicPressure.value
        }
      });
      pressure = null;
    }
  }

  onOilFlowChange(event) {
    var regex = /^\d+$/;
    var oilFlow = event.target.value;
    var isValidOilFlow = regex.test(oilFlow);
    var maxOilFlow = this.props.motorType.oilFlow.value;
    var minOilFlow = maxOilFlow / 2;
    if (!isValidOilFlow) {
      this.setState({
        oilFlowHelpText: "Not a valid value. Value should be only numbers"
      });
    } else if (parseInt(oilFlow, 10) < minOilFlow) {
      this.setState({ oilFlowHelpText: "Value too low", calcRopeSpeed: 0 });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        ropeSpeed: {
          ...this.props.motorType.ropeSpeed,
          calculatedRopeSpeed: null,
          actualValue: this.props.motorType.ropeSpeed.value
        },
        oilFlow: {
          ...this.props.motorType.oilFlow,
          enteredValue: null,
          actualValue: this.props.motorType.oilFlow.value
        }
      });
    } else if (parseInt(oilFlow, 10) > maxOilFlow) {
      this.setState({ oilFlowHelpText: "Value too high", calcRopeSpeed: 0 });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        ropeSpeed: {
          ...this.props.motorType.ropeSpeed,
          calculatedRopeSpeed: null
        },
        oilFlow: {
          ...this.props.motorType.oilFlow,
          enteredValue: null
        }
      });
    } else if (parseInt(oilFlow, 10) === maxOilFlow) {
      this.setState({
        oilFlowHelpText: "Value same as standard value",
        calcRopeSpeed: 0
      });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        ropeSpeed: {
          ...this.props.motorType.ropeSpeed,
          calculatedRopeSpeed: null
        },
        oilFlow: {
          ...this.props.motorType.oilFlow,
          enteredValue: null
        }
      });
    } else {
      var rSpeed = this.props.motorType.ropeSpeed.value;
      var reqRopeSpeed = Math.floor((rSpeed * oilFlow) / maxOilFlow);
      this.setState({ oilFlowHelpText: "" });
      this.setState({ calcRopeSpeed: reqRopeSpeed });
      this.props.onMotorTypeSelect({
        ...this.props.motorType,
        ropeSpeed: {
          ...this.props.motorType.ropeSpeed,
          calculatedRopeSpeed: reqRopeSpeed
        },
        oilFlow: {
          ...this.props.motorType.oilFlow,
          enteredValue: parseInt(oilFlow, 10)
        }
      });
      oilFlow = null;
    }
  }

  selectHoistingForce(event) {
    if (event.target.checked) {
      this.setState({
        showHoistingForce: true,
        calcPressure: 0
      });
    } else {
      this.setState(
        {
          showHoistingForce: false,
          calcPressure: 0
        },
        () => {
          this.props.onMotorTypeSelect({
            ...this.props.motorType,
            hoistingForce: {
              ...this.props.motorType.hoistingForce,
              calcHoistingForce: null,
              name: this.props.motorType.hoistingForce.value
                .toString()
                .includes(".")
                ? this.props.motorType.hoistingForce.value
                    .toString()
                    .replace(".", ",")
                : this.props.motorType.hoistingForce.value.toString() + ",0"
            },
            hydraulicPressure: {
              ...this.props.motorType.hydraulicPressure,
              enteredValue: null
            }
          });
        }
      );
    }
  }

  selectRopeSpeed(event) {
    if (event.target.checked) {
      this.setState({
        showRopeSpeed: true,
        calcRopeSpeed: 0
      });
    } else {
      this.setState(
        {
          showRopeSpeed: false,
          calcRopeSpeed: 0
        },
        () => {
          this.props.onMotorTypeSelect({
            ...this.props.motorType,
            ropeSpeed: {
              ...this.props.motorType.ropeSpeed,
              calculatedRopeSpeed: null
            },
            oilFlow: {
              ...this.props.motorType.oilFlow,
              enteredValue: null
            }
          });
        }
      );
    }
  }

  render() {
    return (
      <div
        className={
          this.props.winchType.orderCode !== "04" &&
          this.props.winchType.orderCode !== "05"
            ? "calculation-container"
            : ""
        }
      >
        <p>
          In case your hydraulic system cannot provide the requested hydraulic
          pressure or the requested oil flow, please click{" "}
          <a onClick={this.showCalcInputs}>here</a> to calculate hoisting force
          and rope speed with your maximum pressure and flow data available in
          your system:
        </p>
        {this.state.showInputs && (
          <div>
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 margin-top-5 pl-0 align-right">
                    <span className="calc_units">Hoisting force at </span>
                  </div>
                  <div className="col-md-8 pl-0">
                    <input
                      name="pressure"
                      className="calculation_inputs"
                      onChange={this.onPressureChange}
                    />{" "}
                    {this.state.pressureUnit}{" "}
                    {this.state.calcPressure !== 0 && (
                      <span className="calc-value">
                        {" "}
                        is{" "}
                        {this.state.calcPressure +
                          " " +
                          this.state.hoistingForceUnit}{" "}
                      </span>
                    )}
                    <span className="help-text">
                      {this.state.pressureHelpText}
                    </span>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 margin-top-5 pl-0 align-right">
                    <span className="calc_units">Rope speed at</span>
                  </div>
                  <div className="col-md-8 pl-0">
                    <input
                      name="oil-flow"
                      className="calculation_inputs"
                      onChange={this.onOilFlowChange}
                    />{" "}
                    {this.state.oilFlowUnit}{" "}
                    {this.state.calcRopeSpeed !== 0 && (
                      <span className="calc-value">
                        {" "}
                        is{" "}
                        {this.state.calcRopeSpeed +
                          " " +
                          this.state.ropeSpeedUnit}
                      </span>
                    )}
                    <span className="help-text">
                      {this.state.oilFlowHelpText}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <div className="row">
          {this.state.showHoistingForce && (
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-4 margin-top-5 pl-0 align-right">
                  <span className="calc_units">Hoisting force at </span>
                </div>
                <div className="col-md-8 pl-0">
                  <input
                    name="pressure"
                    className="calculation_inputs"
                    onChange={this.onPressureChange}
                  />{" "}
                  {this.state.pressureUnit}{" "}
                  {this.state.calcPressure !== 0 && (
                    <span className="calc-value">
                      {" "}
                      is{" "}
                      {this.state.calcPressure +
                        " " +
                        this.state.hoistingForceUnit}{" "}
                    </span>
                  )}
                  <span className="help-text">
                    {this.state.pressureHelpText}
                  </span>
                </div>
                <br />
                <br />
              </div>
            </div>
          )}
          {this.state.showRopeSpeed && (
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-4 margin-top-5 pl-0 align-right">
                  <span className="calc_units">Rope speed at</span>
                </div>
                <div className="col-md-8 pl-0">
                  <input
                    name="oil-flow"
                    className="calculation_inputs"
                    onChange={this.onOilFlowChange}
                  />{" "}
                  {this.state.oilFlowUnit}{" "}
                  {this.state.calcRopeSpeed !== 0 && (
                    <span className="calc-value">
                      {" "}
                      is{" "}
                      {this.state.calcRopeSpeed +
                        " " +
                        this.state.ropeSpeedUnit}
                    </span>
                  )}
                  <span className="help-text">
                    {this.state.oilFlowHelpText}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    motorType: state.motorType,
    mType: state.mType,
    winchType: state.winchType,
    drumSurface: state.drumSurface
  };
};

const mapActionsToProps = {
  onMotorTypeSelect: updateMotorTypeSelection
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(CalculateHoistingForceAndRopeSpeed);



// WEBPACK FOOTER //
// ./src/components/calculation.js